import { PlayerPopup } from '../../index';
import template from './index.jst';

export class TradePlayerPopup extends PlayerPopup {
	get template(){
		return template;
	}
}

export default TradePlayerPopup;